import CommonOperationClass from '../../../commonOperationClass';

const six = new CommonOperationClass('6');

export default six;
